import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styles from './form-submit.module.css';

const FormSubmit = ({ submitForm, submitted }) => {
  const submitHandler = event => {
    submitForm(event);
  };

  const returnMessage = () => {
    if (submitted === 1) {
      return 'Success';
    } else if (submitted == 2) {
      return 'Sending';
    } else {
      return 'Submit';
    }
  };

  return (
    <React.Fragment>
      <button className={styles.wrapper} onClick={submitHandler} type="submit">
        <span className={styles.submit}>{returnMessage()}</span>
      </button>
    </React.Fragment>
  );
};

FormSubmit.propTypes = {
  submitForm: PropTypes.func,
  submitted: PropTypes.number,
};

export default FormSubmit;



// WEBPACK FOOTER //
// ./src/components/form/form-buttons/form-submit/index.js